import React from 'react';


/**
 * Player component
 * The top level component for the app
 * @class
 */
const Player = React.createClass({
  displayName: 'Player',


  propTypes: {
    data: React.PropTypes.object.isRequired,
    style: React.PropTypes.object,
    className: React.PropTypes.string,
    imagePath: React.PropTypes.string.isRequired,
    currentCategory: React.PropTypes.object.isRequired,
    windowSize: React.PropTypes.object,
  },


  /**
   * Renders component
   * @returns {ReactElement} A React element
   */
  render() {
    const data = this.props.data;
    const style = this.props.style;
    const additionalClass = ' ' + this.props.className;
    const eastWestClass = ' ew-' + data.categories[0].divisionId;
    const className = 'component-player' + eastWestClass + additionalClass;
    let additionalData;

    if (this.props.windowSize && this.props.windowSize.width >= 768) {
      additionalData = data.categories[this.props.currentCategory.id].additionalData;
    }

    return (React.createElement("div", {style: style, className: className}, 
      React.createElement("div", {className: "image"}, 
        React.createElement("img", {src: this.props.imagePath + '/small/' + data.image})
      ), 
      React.createElement("div", {className: "text"}, 
        React.createElement("div", {className: "name"}, data.name), 
        React.createElement("div", {className: "secondary-info"}, additionalData)
      )
    ));
  },
});


export default Player;
